import { loadAll } from "@tsparticles/all";
import { initParticlesEngine } from "@tsparticles/react";

export const setupParticlesEngine = () => {
  void initParticlesEngine(loadAll);
};
